import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiOfferSet } from '../../api';

@Component({
  selector: 'tyt-donations-goals',
  templateUrl: './donations-goals.component.html',
  styleUrls: ['./donations-goals.component.scss']
})
export class DonationsGoalsComponent {
  constructor(
    private activatedRoute: ActivatedRoute
  ) { }

  @Input() offerSet: ApiOfferSet;
  @Input() period: string;

  mode: 'membership' | 'contribution';

  // TODO: We need to duplicate the period selection logic here because we don't have a clear path
  // to send the current period from the pricing step to this component. Ideally we should make a
  // way for that to happen instead of duplicating it here.

  periodLabels: Record<string, string> = {
    one_time: 'One Time',
    monthly: 'Monthly',
    annually: 'Annually'
  };

  ngOnInit() {
    const currentPeriod = this.period ?? this.offerSet?.default_period;
    // alert(`Current Period Value IS: ${currentPeriod}`); // Erase After Testing
    this.determinePage(currentPeriod);
  }

  determinePage(period: string) {
    let selectedPeriod: string;

    if (this.periodLabels[period]) {
      selectedPeriod = period;
    } else {
      selectedPeriod = 'monthly';
    }

    this.mode = selectedPeriod === 'one_time' ? 'contribution' : 'membership';
  }
}
